import fetch from '../core/fetch';
import { parseResponse } from '../core/fetch/response';
import Cookie from './cookie';
import Cognito from './cognito';

export const parsePromoCode = code => {
  if (code && typeof code == 'string') {
    return code.toLowerCase();
  }
  return code;
};

export default class Subscriptions {
  static async redeem(attributes) {
    const utm = Cookie.getUtms();
    const clickref = Cookie.getClickRef();
    const affiliateId = Cookie.getAffiliateId();
    const {
      firstName,
      lastName,
      userID,
      redemptionCode,
      playSubscriptionStatus,
      email,
      city,
      state,
      country,
      postal,
    } = attributes;
    const countryCode = Cookie.getCountry() || country;
    let url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/prepaid/subscriptions/renew`;
    const transactionData = {
      'user-id': userID,
      'redemption-code': redemptionCode,
      'first-name': firstName,
      'last-name': lastName,
      email,
      city,
      state,
      country: countryCode,
      postal,
      'utm-campaign': utm.utm_campaign,
      'utm-medium': utm.utm_medium,
      'utm-source': utm.utm_source,
      clickref,
      'affiliate-id': affiliateId,
    };
    if (!playSubscriptionStatus || playSubscriptionStatus === 'unsubscribed') {
      url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/prepaid/subscriptions`;
    }
    const session = await Cognito.fetchCognitoCredentials();
    const params = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${session.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(transactionData),
    };
    const response = await fetch(url, params);
    return response;
  }

  static async validatePromoCode(promoCode) {
    const parsedCode = parsePromoCode(promoCode);
    const url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/promos/${parsedCode}/validate`;
    const session = await Cognito.fetchCognitoCredentials();
    const method = 'GET';
    const params = {
      method,
      headers: {
        Authorization: `Bearer ${session.token}`,
        'Content-Type': 'application/json',
      },
    };
    const response = await fetch(url, params);
    return response;
  }

  static async validate(promoCode) {
    const url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/prepaid/code/${promoCode}`;
    const session = await Cognito.fetchCognitoCredentials();
    const method = 'GET';

    const params = {
      method,
      headers: {
        Authorization: `Bearer ${session.token}`,
        'Content-Type': 'application/json',
      },
    };
    const response = await fetch(url, params);
    return response;
  }

  static async getAccountSummary(userID) {
    const url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/subscriptions/summary?user-id=${userID}`;
    const session = await Cognito.fetchCognitoCredentials();
    const { token } = session || {};
    const params = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    return parseResponse(response);
  }

  static async getCityStateZippopotamus(zipCode, countryCode = 'US') {
    // DO NOT USE core/fetch for this. It appends content-type which causes cors request to fail
    return (await window.fetch(`https://api.zippopotam.us/${countryCode}/${zipCode}`, {
      credentials: 'omit',
      headers: { accept: 'application/json', 'sec-fetch-mode': 'cors' },
      mode: 'cors',
    })).json();
  }
}
